module.exports = __webpack_public_path__ + "static/img/pro-3.a8f24f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-3.png
// module id = xpsy
// module chunks = 1